import React from 'react';
import _ from 'lodash';

export const SpotWorkerInputText = ({
  name,
  className,
  value,
  disabled,
  maxLength,
  onChange,
  onBlur,
  afterTextBox,
}) => {
  return disabled ? (
    <span>{value}</span>
  ) : (
    <React.Fragment>
      <input
        id={name}
        type='text'
        name={name}
        className={className}
        maxLength={maxLength ? maxLength : null}
        value={!_.isNil(value) ? value : ''}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
      />
      {afterTextBox && <span>{afterTextBox}</span>}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/spotWorker/SpotWorkerInputText.jsx